module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "con01"
    }
  }, [_c('p', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/Front_Cover",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cover")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/title_page",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Title Page")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ded_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ded01#ded01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dedication")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "epi_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/epi01#epi01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Epigraph")])])])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "fm_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/fm01#fm01"
    }
  }, [_vm._v("The Thing Before the Rest of the Thing")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "intro_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/intro01#intro01"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#ch01"
    }
  }, [_vm._v("Chapter One - In Simplest Terms and Most Convenient Definitions")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#ch02"
    }
  }, [_vm._v("Chapter Two - Sicily on Five Freakouts a Day")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three - Bowls of Pee")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four - Hairapy")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five - My Hero, My Cuisinart")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six - Om Mani Padme Fuck You")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven - Best Little Psych Ward in Carolina")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight - Billy Has a Boner")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine - Maybe, Baby")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten - Funny Business")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven - The Only Living Girl in New York")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "bm_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/bm01#bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Thing at the End of the Thing")])])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ex01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/Excerpt1#ex01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Excerpt from "), _c('i', [_vm._v("Real Artists Have Jobs")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ex01a"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/Excerpt1a#ex01a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: When You Don’t Know What To Do, Ask a Successful Woman")])])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ata_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ata01#ata01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "credit_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/credit01#credit01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Credits")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "copy_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/copy01#copy01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/atp01#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("About the Publisher")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0